/**
 * refreshToken.js
 * Written by: Alex Kasemir
 */
import cookie from 'react-cookies';

import { removeToken } from '../removeToken';

import request from '../../../request/actions';

import { hosts, formatAxiosError } from '../../../../utils';


export const REFRESH_TOKEN_START = `REFRESH_TOKEN_START`;
export const REFRESH_TOKEN_SUCCESS = `REFRESH_TOKEN_SUCCESS`;
export const REFRESH_TOKEN_FAILURE = `REFRESH_TOKEN_FAILURE`;

export const refreshTokenStart = () => ({
  type: REFRESH_TOKEN_START,
});

export const refreshTokenSuccess = (token) => ({
  type: REFRESH_TOKEN_SUCCESS,
  token,
});

export const refreshTokenFailure = (error) => ({
  type: REFRESH_TOKEN_FAILURE,
  error,
});


/**
 * Description of the refreshToken action
 */
export const refreshToken = (token) => {
  return async (dispatch) => {
    dispatch(refreshTokenStart());
    try {
      const response = await dispatch(request(`/auth/token-refresh/`, `POST`, { token }));
      cookie.save(`jwtToken`, response.data.token, {
        path: `/`,
        expires: new Date(253402300000000),
        domain: hosts.cookieDomain,
      });
      dispatch(refreshTokenSuccess(response.data.token));
    } catch (e) {
      dispatch(removeToken());
      dispatch(refreshTokenFailure(e));
      if (e instanceof Error) {
        throw e;
      }
      const errMsg = formatAxiosError(`refreshToken`, e);
      throw new Error(errMsg);
    }
  };
};
